'use client';

import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

type AuthModalType =
  | 'sign in'
  | 'sign up'
  | 'forgot password'
  | 'verify'
  | 'verify forgot password'
  | 'set new password'
  | 'wrong code'
  | 'password changed'
  | 'add country'
  | 'twitter'
  | 'socialSignup'
  | 'social-profile'
  | undefined;

type IAuthContext = {
  mode: AuthModalType;
  setMode: (mode: AuthModalType) => void;
  email: string;
  setEmail: (email: string) => void;
  username: string;
  setUsername: (username: string) => void;
  setNewPassword: (code: string) => void;
  newPasswordCode: string;
  password: string;
  setPassword: (password: string) => void;
  country: string;
  setCountry: (country: string) => void;
  birthDate: string;
  setBirthDate: (birthDate: string) => void;
  attempts: number;
  setAttempts: (attempt: number) => void;
  counter: number;
  MAX_LOGIN_ATTEMPT: number;
  setCounter: (attempt: number) => void;
  error: string;
  setError: (errorMsg: string) => void;
};

export const AuthContext = createContext({} as IAuthContext);

export const useAuthContext = () => useContext(AuthContext);

export const AuthContextProvider: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [mode, setMode] = useState<AuthModalType>(undefined);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [username, setUsername] = useState('');
  const [newPasswordCode, setNewPasswordCode] = useState('');
  const [password, setPassword] = useState('');
  const [country, setCountry] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [counter, setCounter] = useState(0);
  const MAX_LOGIN_ATTEMPT = 5;

  useEffect(() => {
    localStorage.setItem('counter', counter.toString());
    const timer =
      counter > 0 && setInterval(() => setCounter((time) => time - 1), 1000);
    if (counter <= 0) {
      setAttempts(0);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter]);
  useEffect(() => {
    localStorage.setItem('attempts', attempts.toString());
    if (attempts === 0) {
      localStorage.removeItem('attempts');
      localStorage.removeItem('counter');
    }
  }, [attempts]);

  useEffect(() => {
    const atte = localStorage.getItem('attempts') ?? '0';
    const counter = localStorage.getItem('counter') ?? '0';
    if (parseInt(atte) >= 5) {
      setCounter(parseInt(counter) > 0 ? parseInt(counter) : 60);
    }
    setAttempts(parseInt(atte));
  }, []);

  const setNewPassword = (code: string) => {
    setNewPasswordCode(code);
    setMode('set new password');
  };

  return (
    <AuthContext.Provider
      value={{
        mode,
        setMode,
        email,
        setEmail,
        setUsername,
        username,
        setNewPassword,
        newPasswordCode,
        password,
        setPassword,
        country,
        setCountry,
        birthDate,
        setBirthDate,
        attempts,
        setAttempts,
        counter,
        setCounter,
        MAX_LOGIN_ATTEMPT,
        error,
        setError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
